import type { TRaffleResponse } from './models';

import { KEGatewayClient } from '../KEGatewayClient';

export class _RaffleClient extends KEGatewayClient {
  public async getRafflePromo(cost: number) {
    return this.get<TRaffleResponse>(
      `min-price-promotions/active?price=${Math.round(cost)}&type=DESKTOP`
    );
  }
}

export const RaffleClient = new _RaffleClient();
